import { Col, Row } from "antd";
import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const Page = () => {
  // Static data for the chart
  const staticSeries = [
    {
      name: "Series 1",
      data: [31, 40, 28, 51, 42, 109, 100],
    },
  ];
  const staticLabels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"];

  const [series, setSeries] = useState(staticSeries);
  const [options, setOptions] = useState({
    chart: {
      type: "area",
      height: 350,
      zoom: {
        enabled: true,
      },
      toolbar: {
        show: true,
        offsetX: 0,
        offsetY: 0,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true | '<img src="/static/icons/reset.png" width="20">',
          customIcons: [],
        },
        autoSelected: "zoom",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    title: {
      text: "Data",
      align: "left",
    },
    subtitle: {
      text: "Subtitle",
      align: "left",
    },
    labels: staticLabels,
    xaxis: {
      tickPlacement: "on",
    },
    yaxis: {
      opposite: true,
    },
    legend: {
      horizontalAlign: "left",
    },
    tooltip: {
      enabled: true,
    },
  });

  return (
    <div className="p-5">
      <Row gutter={16}>
        <Col span={12}>
          <div id="chart">
            <ReactApexChart
              options={options}
              series={series}
              type="area"
              width={500}
            />
          </div>
        </Col>{" "}
        <Col span={12}>
          <div id="chart">
            <ReactApexChart
              options={options}
              series={series}
              type="scatter"
              width={500}
            />
          </div>
        </Col>
        <Col span={12}>
          <div id="chart">
            <ReactApexChart
              options={options}
              series={series}
              type="bar"
              width={500}
            />
          </div>
        </Col>
        <Col span={12}>
          <div id="chart">
            <ReactApexChart
              options={options}
              series={series}
              type="line"
              width={500}
            />
          </div>
        </Col>
      </Row>
      <div id="html-dist"></div>
    </div>
  );
};

export default Page;
